import React from "react";

const OrderStatusRed = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_579" transform="translate(-1081 -393)">
        <g
          id="Ellisse_25"
          transform="translate(1086 398)"
          fill="#fc5959"
          stroke="#fff"
          strokeWidth="1"
        >
          <circle cx="11" cy="11" r="11" stroke="none" />
          <circle cx="11" cy="11" r="10.5" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default OrderStatusRed;
